module.exports = __webpack_public_path__ + "static/Grafik_Download.a1ba5357.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GrafikPDFDownload/Grafik_Download.svg
// module id = 445
// module chunks = 35783957827783